<template>
    <!-- 页头 -->
    <div class="headerOuter">
        <div class="header-page">
          <div class="page-center">
              <div class="header">
                  <div class="logoPart">
                      <a href="//www.huanqiu.com" target="_blank" class="logo" title="环球网"></a>
                      <span class="pageTitle">
                          {{headTitle}}
                      </span>
                      <span class="searchBar">
                          <!-- <span class="searchIcon"></span> -->
                      <span class="listIcon zoomIn" :class="[{'close-btn': isClose},{'zoomIn2': isClose}]" @click="changeIndex()"></span>
                      </span>
                  </div>
              </div>
          </div>
        </div>
        
        <div class="navFlyout" v-if="show">
          <div class="nav-flyout-container">
            <div class="nav-flyout-menu-item s-hight">
                <div class="nav-flyout-menu-item-title">
                    <h3>时政<span style="margin: 10px;"></span></h3>
                    <h4>Politics<span style="margin: 10px;"></span></h4>
                </div>
                <ul class="nav-flyout-menu-item-list">
                    <li><a href="//world.huanqiu.com" target="_blank"><span class="name-cn">国际</span><span class="name-en">World</span></a></li>
                    <li><a href="//china.huanqiu.com" target="_blank"><span class="name-cn">国内</span><span class="name-en">China</span></a></li>
                    <li><a href="//mil.huanqiu.com" target="_blank"><span class="name-cn">军事</span><span class="name-en">Military</span></a></li>
                    <li><a href="//taiwan.huanqiu.com" target="_blank"><span class="name-cn">台湾</span><span class="name-en">Taiwan</span></a></li>
                    <li><a href="//society.huanqiu.com" target="_blank"><span class="name-cn">社会</span><span class="name-en">Society</span></a></li>
                    <li><a href="//look.huanqiu.com" target="_blank"><span class="name-cn">博览</span><span class="name-en">Look</span></a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item s-hight">
                <div class="nav-flyout-menu-item-title">
                    <h3>财经<span style="margin: 10px;">&amp;</span>科技</h3>
                    <h4>Finance<span style="margin: 10px;">&amp;</span>Technology</h4>
                </div>
                <ul class="nav-flyout-menu-item-list long">
                    <li><a href="//finance.huanqiu.com" target="_blank"><span class="name-cn">财经</span><span class="name-en">Financial</span></a></li>
                    <li><a href="//finance.huanqiu.com/br/picks" target="_blank"><span class="name-cn">一带一路</span><span class="name-en">Belt and Road</span></a></li>
                    <li><a href="//finance.huanqiu.com/observation" target="_blank"><span class="name-cn">财观察</span><span class="name-en">Observation</span></a></li>
                    <li><a href="//tech.huanqiu.com" target="_blank"><span class="name-cn">科技</span><span class="name-en">Technology</span></a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item s-hight">
                <div class="nav-flyout-menu-item-title">
                    <h3>汽车<span style="margin: 10px;">&amp;</span>数码</h3>
                    <h4>Auto<span style="margin: 10px;">&amp;</span>Digital</h4>
                </div>
                <ul class="nav-flyout-menu-item-list long3">
                    <li><a href="//auto.huanqiu.com" target="_blank"><span class="name-cn">汽车</span><span class="name-en">Auto</span></a></li>
                    <li><a href="//smart.huanqiu.com" target="_blank"><span class="name-cn">智能</span><span class="name-en">Smart</span></a></li>
                    <li><a href="//tech.huanqiu.com/diginews" target="_blank"><span class="name-cn">数码</span><span class="name-en">Digital</span></a></li>
                    <li><a href="//uav.huanqiu.com" target="_blank"><span class="name-cn">无人机</span><span class="name-en">UAV</span></a></li>
                    <li><a href="//game.huanqiu.com" target="_blank"><span class="name-cn">游戏</span><span class="name-en">Game</span></a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item">
                <div class="nav-flyout-menu-item-title">
                    <h3>生活</h3>
                    <h4>Life News</h4>
                </div>
                <ul class="nav-flyout-menu-item-list">
                    <li><a href="//go.huanqiu.com" target="_blank"><span class="name-cn">文旅</span><span class="name-en">Tourism</span></a></li>
                    <li><a href="//health.huanqiu.com" target="_blank"><span class="name-cn">健康</span><span class="name-en">Health</span></a></li>
                    <li><a href="//lx.huanqiu.com" target="_blank"><span class="name-cn">教育</span><span class="name-en">Education</span></a></li>
                    <li><a href="//quality.huanqiu.com" target="_blank"><span class="name-cn">质量</span><span class="name-en">Quality</span></a></li>
                    <li><a href="//sports.huanqiu.com" target="_blank"><span class="name-cn">体育</span><span class="name-en">Sports</span></a></li>
                    <li><a href="//run.huanqiu.com" target="_blank"><span class="name-cn">跑步</span><span class="name-en">Run</span></a></li>
                    <li><a href="//ski.huanqiu.com" target="_blank"><span class="name-cn">滑雪</span><span class="name-en">Skiing</span></a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item">
                <div class="nav-flyout-menu-item-title">
                    <h3>风尚</h3>
                    <h4>Fashion News</h4>
                </div>
                <ul class="nav-flyout-menu-item-list">
                    <li><a href="//ent.huanqiu.com" target="_blank"><span class="name-cn">娱乐</span><span class="name-en">Entertainment</span></a></li>
                    <li><a href="//fashion.huanqiu.com" target="_blank"><span class="name-cn">时尚</span><span class="name-en">Fashion</span></a></li>
                    <li><a href="//art.huanqiu.com" target="_blank"><span class="name-cn">艺术</span><span class="name-en">Art</span></a></li>
                    <li><a href="//luxury.huanqiu.com" target="_blank"><span class="name-cn">品鉴</span><span class="name-en">Luxury</span></a></li>
                    <li><a href="//cul.huanqiu.com" target="_blank"><span class="name-cn">文化</span><span class="name-en">Culture</span></a></li>
                    <li><a href="//hope.huanqiu.com" target="_blank"><span class="name-cn">公益</span><span class="name-en">Commonweal</span></a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item">
                <div class="nav-flyout-menu-item-title">
                    <h3>特色<span style="margin: 10px;">&amp;</span>产品</h3>
                    <h4>Featured<span style="margin: 10px;">&amp;</span>Products</h4>
                </div>
                <ul class="nav-flyout-menu-item-list long2">
                    <li><a href="//opinion.huanqiu.com/editorial/" target="_blank"><span class="name-cn">环球社评</span><span class="name-en">Editorial</span></a></li>
                    <li><a href="//oversea.huanqiu.com" target="_blank"><span class="name-cn">海外看中国</span><span class="name-en">Oversee</span></a></li>
                    <li><a href="//mobile.huanqiu.com/#time" target="_blank"><span class="name-cn">环球 TIME</span><span class="name-en"></span></a></li>
                    <li><a href="//mp.huanqiu.com/" target="_blank"><span class="name-cn">环游号</span><span class="name-en"></span></a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item">
                <div class="nav-flyout-menu-item-title">
                    <h3>环球时报</h3>
                    <h4>Newspaper Products</h4>
                </div>
                <ul class="nav-flyout-menu-item-list">
                    <li><a href="//data.huanqiu.com" target="_blank">
                            <p>版权数据库</p>
                        </a></li>
                    <li><a href="//www.lifetimes.cn" target="_blank">
                            <p>生命时报</p>
                        </a></li>
                    <li><a href="//hd.globaltimes.cn" target="_blank">
                            <p>品牌活动</p>
                        </a></li>
                    <li><a href="//globaltraveler.cn" target="_blank">
                            <p>环球旅游周刊</p>
                        </a></li>
                    <li><a href="//www.gtfoundation.cn" target="_blank">
                            <p>环球时报公益基金会</p>
                        </a></li>
                    <li><a href="//humor.huanqiu.com" target="_blank">
                            <p>讽刺与幽默</p>
                        </a></li>
                    <li><a href="//www.globaltimes.cn" target="_blank">
                            <p>Global Times</p>
                        </a></li>
                </ul>
            </div>
            <div class="nav-flyout-menu-item">
                <div class="nav-flyout-menu-item-title">
                    <h3>合作</h3>
                    <h4>Cooperation</h4>
                </div>
                <ul class="nav-flyout-menu-item-list long3">
                    <li><a href="//chamber.huanqiu.com" target="_blank"><span class="name-cn">商协会</span><span class="name-en">Chamber</span></a></li>
                    <li><a href="//bigdata.huanqiu.com" target="_blank"><span class="name-cn">大数据</span><span class="name-en">Bigdata</span></a></li>
                    <li><a href="//biz.huanqiu.com" target="_blank"><span class="name-cn">商业</span><span class="name-en">Business</span></a></li>
                    <li><a href="//city.huanqiu.com" target="_blank"><span class="name-cn">城市</span><span class="name-en">City</span></a></li>
                    <li><a href="//qinzi.huanqiu.com" target="_blank"><span class="name-cn">亲子</span><span class="name-en">Qinzi</span></a></li>
                </ul>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "app-header",
  components: {},
  data() {
    return {
      show:false,
      isClose: false,
    };
  },
  props:{
    // 必填的字符串
    headTitle: {
      type: String,
      required: true
    },
  },
  computed: {},
  watch: {},
  methods: {
    changeIndex(){
      this.show=!this.show;
      this.isClose = false
      if(this.show){
        this.isClose = true
      }
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
/* 页头 */
.page-center {
  width: 1000px;
  margin: 0 auto;
}

.header-page {
  background-color: #90080e;
}

.header {
  height: 40px;
}

.header .logoPart {
  height: 40px;
  overflow: hidden;
}

.header .logoPart a.logo {
  float: left;
  width: 70px;
  height: 40px;
  // margin-top: 8px;
  background: url(../../assets/images/LOGO1.png) no-repeat -5px center;
  background-size: 100%;
  margin-right: 38px;
}

.header .logoPart span.pageTitle {
  float: left;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #fff;
  font-family: "MicrosoftYaHei";
}

.header .logoPart span.searchBar {
  float: right;
}

.header .logoPart .searchBar span {
  float: left;
  width: 20px;
  height: 28px;
  margin: 6px 0;
  cursor: pointer;
}

.header .logoPart .searchBar .searchIcon {
  background: url(../../assets/images/icons.png) -166px -12px no-repeat;
  margin-right: 10px;
}

.header .logoPart .searchBar .listIcon {
  background: url(../../assets/images/icons.png) -196px -12px no-repeat;
}

.header .logoPart .searchBar .close-btn{
  background: url(../../assets/images/headClose.png) no-repeat center;
  background-size: 100%;
}

.navFlyout p,.navFlyout ul,.navFlyout li, {
    margin: 0;
    padding: 0;
    list-style: none;
}

.navFlyout a{
    text-decoration: none;
}

.navFlyout {
  font-size: 16px;
  max-height: none;
  padding: 0;
  position: absolute;
  width: 100%;
  height: 638px;
  opacity: 0.99;
  background: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  box-shadow: 0 2px 10px 0 rgba(215,215,215,0.50);
  z-index:100000;
}

.navFlyout{background: #000000;filter:alpha(opacity=90);-moz-opacity:0.9;-khtml-opacity:0.9;opacity:0.9;max-height: none;padding: 0;position: absolute;width: 100%;height: 638px;}
.navFlyout .nav-flyout-container{ margin: 0 auto; max-width: 1000px; padding: 20px 0; overflow: hidden;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item{float: left; width: 23%;height: 285px; padding: 0 20px 0 0;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item.no-right{padding-right: 0;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title{margin-bottom: 10px;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title span{font-size:14px;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title h3{font-size: 18px; color: #ffffff; letter-spacing: 0.6px; line-height: 30px;font-weight: normal;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title h4{font-size: 16px; color: #ffffff; letter-spacing: 0.53px; line-height: 18px;font-weight: normal;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li{margin: 5px 0;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li a{font-size: 14px;color: #bfbfbf; letter-spacing: 0.4px; line-height: 22px;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li a:hover{color: #ffffff;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li span{display: inline-block;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li .name-cn{width: 18%;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li .name-en{width: 60%;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list.long li .name-cn{width: 31%;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list.long2 li .name-cn{width: 37%;}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list.long3 li .name-cn{width: 25%;}
@media screen and (max-width:960px){
    .navTopSec,.navFlyout .nav-flyout-container{max-width: 630px;}
    .navTopSec .nav-container .nav-section .nav-section-article-title{max-width: 450px;letter-spacing:0;}
    .navFlyout{height:735px;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item{padding: 0 8px 0 0;width: 32%;height:239px;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item.s-hight{height:215px;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li a{line-height: 18px;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title{ margin-bottom: 15px;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li{margin:0;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li p{line-height: 22px;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li .name-en{width:50%;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list.long li .name-cn{width:34%;}
    .navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list.long2 li .name-cn{width:40%;}
}
@keyframes zoomIn {0% {opacity: 0;-webkit-transform: scale3d(.3, .3, .3);transform: scale3d(.3, .3, .3);} 50%{opacity: 1;}}
@keyframes zoomIn2 {50% { opacity: 1;}0% {opacity: 0.1;-webkit-transform: scale3d(.3, .3, .3);transform: scale3d(.3, .3, .3);}}
@-webkit-keyframes zoomIn {0% {opacity: 0;-webkit-transform: scale3d(.3, .3, .3);transform: scale3d(.3, .3, .3);}50% {opacity: 1;}}
@-webkit-keyframes zoomIn2 {50% {opacity: 1;}0% { opacity: 0.1; -webkit-transform: scale3d(.3, .3, .3); transform: scale3d(.3, .3, .3);}}
.zoomIn {-webkit-animation-name: zoomIn;animation-name: zoomIn;animation-duration: .5s;}
.zoomIn2 {-webkit-animation-name: zoomIn2;animation-name: zoomIn2;animation-duration: .5s;}

.navFlyout{
    background: #F5F5F5;
    filter:alpha(opacity=99); -moz-opacity:0.99; -khtml-opacity:0.99; opacity:0.99;
    
}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title h3{
    color: #000;
}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-title h4{
    color: #000;
}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li a{
    color:#333;
}
.navFlyout .nav-flyout-container .nav-flyout-menu-item .nav-flyout-menu-item-list li a:hover{
    color:#90080E;
}
.hdTop{border:none;}
.l-line{
    display: inline-block;
    width: 1px;
    height: 15px;
    background: #A6393E;
    margin-bottom: 18px;
    margin-left: 3px;
}
.navTopSec .nav-container .nav-section .nav-section-submenu i{color: #fff!important;}
@media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2) {

    .navTopSec .nav-container .search-form .search-button,
    .navTopSec .nav-container .search-form .search-button.open,
    .navTopSec .nav-container .nav-menu,
    .navTopSec .nav-container .nav-menu.close-btn{
        background-image:url(//rs2.huanqiucdn.cn/huanqiu/image/www/detail/hqicon_2x.png);
        background-size:400px auto;
    }

}
@supports ((-webkit-backdrop-filter: saturate(180%) blur(20px)) or (backdrop-filter: saturate(180%) blur(20px))) {
    body .navFlyout {
        background: rgba(255, 255, 255, 0.8);
        -webkit-backdrop-filter: saturate(180%) blur(20px);
        backdrop-filter: saturate(180%) blur(20px);
        box-shadow: 0 2px 10px 0 rgba(215,215,215,0.50);
    }
}

</style>


// WEBPACK FOOTER //
// src/components/common/header.vue